/**
 * @description get object then loop in it to get object value key 
 * @param obj Object
 * @returns any
 */
export const chainKeyForValue = (obj: any): any | null => {

    /**
     * 
     */
    if (obj == null) return null;

    /**
     * 
     */
    if (typeof obj !== 'object') return null;

    /**
     * init
     */
    let value: any = null;

    /**
     * loop in obj
     */
    for (const key in obj) {
      if (obj[key]?.toString()) {
        value = obj[key]
        break;
      }
    }

    /**
     * 
     */
    return value;

}